import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const RecoupLedgers = () => {
  const addLedger = (id, data) =>
    AuthAxios.post(`${DataApiUrl}/admin/recoupAccounts/${id}/ledgers`, data)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });
  //The backend only allows to change note, or set voided to true
  const editLedger = (id, data) =>
    AuthAxios.patch(`${DataApiUrl}/admin/recoupLedgers/${id}`, data)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  return {
    editLedger,
    addLedger,
  };
};

export default RecoupLedgers;
